import React from 'react'

const Footer = () => {
    return (
        <div className='p-2 d-flex align-items-center' style={{ backgroundColor: "rgb(9 24 59)" }}>
            <div className="container-fluid d-flex align-items-center justify-content-center">
                <h6 className='text-center text-light text-style mt-2'>&copy;2025 AIRBUS</h6>
            </div>
        </div>
    )
}

export default Footer
